import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MatSpinnerOverlayComponent } from './mat-spinner-overlay/mat-spinner-overlay.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@bluehalo/ngx-leaflet-draw';
import { MapComponent } from './map/map.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { GlobalValidationMessageComponent } from './global-validation-message/global-validation-message.component';

@NgModule({
  declarations: [
  ],
  imports: [
    HeaderComponent,
    FooterComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSpinnerOverlayComponent,
    LeafletModule,
    LeafletDrawModule,
    NgxFileDropModule,
    MapComponent,
    GlobalValidationMessageComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    MatSpinnerOverlayComponent,
    MapComponent,
    NgxFileDropModule,
    GlobalValidationMessageComponent
  ]
})
export class SharedModule { }
